export var QuestionnaireHistory;
(function (QuestionnaireHistory) {
    QuestionnaireHistory["HISTORY"] = "QuestionnaireHistory/History";
    QuestionnaireHistory["HISTORY_SUCESSFUL"] = "QuestionnaireHistory/History_Sucessful";
    QuestionnaireHistory["RESPONSE_HISTORY_1"] = "QuestionnaireHistory/Response_1_History";
    QuestionnaireHistory["RESPONSE_HISTORY_1_SUCESSFUL"] = "QuestionnaireHistory/Response_1_History_Sucessful";
    QuestionnaireHistory["RESPONSE_HISTORY_2"] = "QuestionnaireHistory/Response_2_History";
    QuestionnaireHistory["RESPONSE_HISTORY_2_SUCESSFUL"] = "QuestionnaireHistory/Response_2_History_Sucessful";
    QuestionnaireHistory["RESPONSE_HISTORY_MILESTONE"] = "QuestionnaireHistory/Response_Milestone_History";
    QuestionnaireHistory["RESPONSE_HISTORY_MILESTONE_SUCESSFUL"] = "QuestionnaireHistory/Response_Milestone_History_Sucessful";
    QuestionnaireHistory["PERSONAL_WELLBEING_HISTORY"] = "QuestionnaireHistory/Personal_Wellbeing_History";
    QuestionnaireHistory["PERSONAL_WELLBEING_HISTORY_SUCCESSFUL"] = "QuestionnaireHistory/Personal_Wellbeing_History_Successful";
})(QuestionnaireHistory || (QuestionnaireHistory = {}));
